export interface DuplicateClaimResponse {
    hayDuplicados:          boolean;
    siniestrosEquivalentes: EquivalentClaims[];
}

export interface DuplicateClaimParams {
    fechaOcurrencia:    string;
    horaOcurrencia:     string;
    tipoBusq:           string;
    patente?:           string;
    rama?:              string;
    numeroPoliza?:      string;
}

export interface EquivalentClaims {
    rama:              number;
    numero:            number;
    fechaNotificacion: string;
    fechaOcurrencia:   string;
    horaOcurrencia:    string;
    esDuplicado:       boolean;
}

export enum DuplicateClaimServiceType {
    GET_BY_PATENT = "P",
    GET_BY_POLICY = "R"
}
